export const ITEM_BASED_LINE_ITEMS_CALCULATION_DEBOUNCE = 200;
